import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';
import { BackArrow } from "../../../shared/svgIcons.jsx";
import ReduxFileWidget from '../../../shared/redux-file-widget';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  padding: .5rem;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;


const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: .5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const ContractorStep12 = ( { incrementStep, decrementStep, setFormData, formData } ) => {
  const validated = formData.proofOfPurchaseFiles;

  const onChangeUpload = (files) => {
    setFormData({ proofOfPurchaseFiles: files });
  };

  return(
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 13 - please upload your proof of purchase"
        onClick={decrementStep}>
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>
          Did you install any Owens Corning components?
        </BackText>
      </BackWrapper>
      <IntroMessage>
        Thanks for that!
      </IntroMessage>
      <Header>Please upload your proof of purchase.</Header>
      <IntroMessage>
        You can provide either a copy of your invoice to the homeowner or a copy of your distributor invoice.
         Any asset uploaded will remain private and will only be used in the case that the homeowner files a claim.
      </IntroMessage>
      <InputWrapper>
        <ReduxFileWidget onChange={onChangeUpload} />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 13 - please upload your proof of purchase"
        onClick={incrementStep} disabled={!validated}>Next</NextButton>
      <Subscript onClick={incrementStep}>
        Skip this step for now
      </Subscript>
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorStep12);
